import React from 'react';
import { useI18n } from '../../i18n';
import './CalendarSkeleton.css';

// Day indices (0-based within the 35-cell grid) that carry skeleton badge placeholders.
// Chosen to look like a natural, sparse meeting distribution.
const BADGE_MAP = {
    5: 1,  // 1 badge
    9: 2,  // 2 badges (busy day)
    16: 1,
    19: 1,
    25: 1,
    28: 2,  // 2 badges
};

const CalendarSkeleton = () => {
    const { t } = useI18n();
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

    // 35 cells = 5 rows × 7 cols; first 3 are "before month" empty cells
    const cells = Array.from({ length: 35 }, (_, i) => ({
        isEmpty: i < 3,
        badges: BADGE_MAP[i] || 0,
    }));

    if (isMobile) {
        return (
            <div className="cal-sk-wrapper">
                <div className="cal-sk-header-row">
                    <div className="cal-sk-nav" style={{ width: '100%', justifyContent: 'center' }}>
                        <div className="cal-sk-month-title cal-sk-el" style={{ width: 150 }} />
                    </div>
                </div>
                <div className="cal-sk-day-view">
                    <div className="cal-sk-time-col">
                        {Array.from({ length: 12 }).map((_, i) => (
                            <div key={i} className="cal-sk-time-slot cal-sk-el" />
                        ))}
                    </div>
                    <div className="cal-sk-day-col">
                        <div className="cal-sk-event cal-sk-el" style={{ top: '20%', height: '80px' }} />
                        <div className="cal-sk-event cal-sk-el" style={{ top: '45%', height: '60px' }} />
                        <div className="cal-sk-event cal-sk-el" style={{ top: '70%', height: '100px' }} />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="cal-sk-wrapper">

            {/* ── Month navigation header ── */}
            <div className="cal-sk-header-row">
                <div className="cal-sk-nav">
                    <div className="cal-sk-nav-btn cal-sk-el" />
                    <div className="cal-sk-month-title cal-sk-el" />
                    <div className="cal-sk-nav-btn cal-sk-el" />
                </div>
            </div>

            {/* ── Weekday column labels (kept as real text — structural context) ── */}
            <div className="cal-sk-weekdays">
                {[
                    t('pages.calendar.weekdays.sun'),
                    t('pages.calendar.weekdays.mon'),
                    t('pages.calendar.weekdays.tue'),
                    t('pages.calendar.weekdays.wed'),
                    t('pages.calendar.weekdays.thu'),
                    t('pages.calendar.weekdays.fri'),
                    t('pages.calendar.weekdays.sat')
                ].map(d => (
                    <div key={d} className="cal-sk-weekday-label">{d}</div>
                ))}
            </div>

            {/* ── Day grid ── */}
            <div className="cal-sk-grid">
                {cells.map((cell, i) => (
                    <div
                        key={i}
                        className={`cal-sk-day${cell.isEmpty ? ' cal-sk-day--empty' : ''}`}
                    >
                        {!cell.isEmpty && (
                            <>
                                <div className="cal-sk-day-num cal-sk-el" />
                                {Array.from({ length: cell.badges }).map((_, b) => (
                                    <div key={b} className="cal-sk-badge cal-sk-el" />
                                ))}
                            </>
                        )}
                    </div>
                ))}
            </div>

        </div>
    );
};

export default CalendarSkeleton;
